import React from 'react';
import cn from '@/utils/cn';

const cardClass = cn(
  'tw-box-border tw-rounded tw-border tw-border-solid tw-border-spa-border',
  'tw-bg-spa-bg-secondary tw-px-4 tw-py-3',
);

export const MetricLabel = ({ children }: { children: React.ReactNode }) => (
  <div className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-spa-secondary">{children}</div>
);

interface MetricCardProps {
  hint?: string;
  label: string;
  value: React.ReactNode;
}

export const MetricCard = ({ hint, label, value }: MetricCardProps) => (
  <div className={cardClass}>
    <MetricLabel>{label}</MetricLabel>
    <div className="tw-mt-1 tw-text-2xl tw-font-semibold tw-tabular-nums tw-text-spa-heading">{value}</div>
    {hint != null && <div className="tw-mt-1 tw-text-sm tw-text-spa-secondary">{hint}</div>}
  </div>
);

export const MetricCardSkeleton = () => (
  <div aria-hidden="true" className={cn(cardClass, 'tw-animate-pulse')}>
    <div className="tw-h-3 tw-w-24 tw-rounded tw-bg-spa-bg-skeleton" />
    <div className="tw-mt-2.5 tw-h-7 tw-w-16 tw-rounded tw-bg-spa-bg-skeleton" />
    <div className="tw-mt-2 tw-h-3.5 tw-w-32 tw-rounded tw-bg-spa-bg-skeleton-subtle" />
  </div>
);

interface InlineStatProps {
  hint?: string;
  label: string;
  tone?: 'error';
  value: React.ReactNode;
}

// A figure in a row of figures, without a card: the teacher page's account counts, the roster's tallies.
export const InlineStat = ({
  hint, label, tone, value,
}: InlineStatProps) => (
  <div>
    <div
      className={cn(
        'tw-text-xl tw-font-semibold tw-tabular-nums',
        tone === 'error' ? 'tw-text-spa-error' : 'tw-text-spa-heading',
      )}
    >
      {value}
    </div>
    <MetricLabel>{label}</MetricLabel>
    {hint != null && <div className="tw-text-sm tw-text-spa-secondary">{hint}</div>}
  </div>
);
